module.exports = __webpack_public_path__ + "static/media/Layout2.3f55d026.png";